module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_chopvalue_2.336927b2.jpg";